//import React from "react";
import { Form } from "react-bootstrap";
import PropTypes from 'prop-types';

const FormFechas = ({ dataFechas, setDataFechas }) => {
  
  
    const { fechaInicial, fechaFinal } = dataFechas;

    const onChangeFechas = (e) => {
      //console.log(e.target.name,e.target.value);
      setDataFechas({
        ...dataFechas,
        [e.target.name]: e.target.value,
      });
    };
    return (
      <div>
        <Form className="p-2">
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Fecha Inicial:</Form.Label>
            <Form.Control
              type="date"
              value={fechaInicial}
              placeholder="Fecha Inicial"
              name="fechaInicial"
              onChange={onChangeFechas}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Fecha Final:</Form.Label>
            <Form.Control
              value={fechaFinal}
              type="date"
              placeholder="Fecha Inicial"
              name="fechaFinal"
              onChange={onChangeFechas}
            />
          </Form.Group>
        </Form>
      </div>
    );
  };

  FormFechas.propTypes = {
    dataFechas: PropTypes.shape({
      fechaInicial: PropTypes.string.isRequired,
      fechaFinal: PropTypes.string.isRequired,
    }).isRequired,
    setDataFechas: PropTypes.func.isRequired,
  };

  export default FormFechas;

  